import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 660px;
  margin: 0 auto;

  @media (max-width: 480px){
    display: flex;
    flex-direction: column;
    max-width: 100%;
  }

  input {
    width: 100%;
  }
  button {
    margin-top: 20px;
    align-self: center;
  }
`;

export const SearchFormWrapper = styled.div`
  display: flex;
  align-items: center;

  > div {
    width: 50%;
    @media (max-width: 600px){
      width: 100%;
    }
  }
  @media (max-width: 600px){
    flex-direction: column;
  }
  > div:nth-child(2){
    margin-left: 20px;
    @media (max-width: 600px){
      margin-left: 0;
      margin-bottom: 13px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/system/main/records/components.js